import { useState } from 'react'

import { Box, Icon, Text, TogglerCheckbox, Tooltip } from '@factorialco/deprecated-design-system'

export const ToogleCard = ({
  onChange,
  title,
  tooltip,
  tooglerValue,
}: {
  title: string
  tooltip: string
  tooglerValue: boolean
  onChange: (value: boolean) => void
}) => {
  const [hover, setHover] = useState<boolean>(false)

  return (
    <Box
      border={{ all: { width: 's1', color: 'grey400', style: 'solid' } }}
      padding="s16"
      paddingX="s24"
      gap="s16"
      borderRadius={{ all: 'abs008' }}
      flexDirection="row"
      alignItems="flexStart"
      justifyContent="spaceBetween"
    >
      <Box gap="s8" flexDirection="row">
        <Text.Normal weight="medium" color="grey1000">
          {title}
        </Text.Normal>
        <Box onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
          <Tooltip.Alt attachment="bottom center" textAlign="center" label={tooltip} open={hover}>
            <Icon.Medium icon="alert-circle-line" color="grey800" />
          </Tooltip.Alt>
        </Box>
      </Box>

      <TogglerCheckbox value={tooglerValue} onChange={onChange} />
    </Box>
  )
}
